import { useEffect } from "react";

function adjustViewport() {
  const viewport = document.querySelector("meta[name='viewport']");
  const width = window.outerWidth;
  const mobileS = width <= 329;
  const mobileM = width <= 414;
  const mobileL = width <= 768;

  if (mobileS) {
    viewport?.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=0.85, user-scalable=no"
    );
  } else {
    viewport?.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no"
    );
  }
}

export default function useAdjustViewport() {
  useEffect(() => {
    adjustViewport();
    window.addEventListener("resize", adjustViewport);
    return () => {
      window.removeEventListener("resize", adjustViewport);
    };
  }, []);
}
